import { render } from "./Reddit.vue?vue&type=template&id=0426d1dc&ts=true"
import script from "./Reddit.vue?vue&type=script&lang=ts"
export * from "./Reddit.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__